/**
 * Reads the body of a non-ok response without ever failing on non-JSON payloads
 * (e.g. HTML 502/504 pages from a proxy, or empty 5xx bodies).
 * Returns the parsed JSON when possible, otherwise a status-aware fallback object.
 */
export async function parseErrorBody(res: Response): Promise<any> {
    const text = await res.text().catch(() => '');

    try {
        return JSON.parse(text);
    } catch {
        return {
            status: res.status,
            statusText: res.statusText,
            message: text || res.statusText
        };
    }
}

/**
 * Returns the parsed JSON body of an ok response, or throws the parsed error body otherwise.
 */
export async function readJsonOrThrow<T = any>(res: Response): Promise<T> {
    if (!res.ok) {
        throw await parseErrorBody(res);
    }

    return res.json();
}
